import { configureStore } from '@reduxjs/toolkit';
import userReducer from './features/user/user-slice';
import sportReducer from './features/sports/sport-slice';
import eventReducer from './features/events/event-slice';
import marketReducer from './features/market/market-slice';
import bookieReducer from './features/bookie/bookie-slice';
import tipsterReducer from './features/tipster/tipster-slice';
import countryReducer from './features/country/country-slice';
import serviceReducer from './features/service/service-slice';
import discountReducer from './features/discounts/discount-slice';
import participantReducer from './features/participant/participant-slice';
import competitionReducer from './features/competition/competition-slice';
import tipsterTypeReducer from './features/tipster_type/tipster-type-slice';
import advertisementReducer from './features/advertisement/advertisement-slice';
import homePromoCardReducer from './features/home-promo-card/home-promo-card-slice';
import articleReducer from './features/article/article-slice';
import homeEventReducer from './features/home-event/home-event-slice';
import subscriptionReducer from './features/subscription/subscription-slice';
import solicitationReducer from './features/solicitation/solicitation-slice';
// Requests

//Apuestes API
import { apuestesAPI } from './services/apuestesAPI';

export const store = configureStore({
    reducer: {
        user: userReducer,
        event: eventReducer,
        sport: sportReducer,
        bookie: bookieReducer,
        market: marketReducer,
        tipster: tipsterReducer,
        country: countryReducer,
        service: serviceReducer,
        discount: discountReducer,
        tipsterType: tipsterTypeReducer,
        participant: participantReducer,
        competition: competitionReducer,
        advertisement: advertisementReducer,
        homePromoCard: homePromoCardReducer,
        article: articleReducer,
        homeEvent: homeEventReducer,
        subscription: subscriptionReducer,
        solicitation: solicitationReducer,
        [apuestesAPI.reducerPath]: apuestesAPI.reducer,
    },
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
        serializableCheck: {
            ignoreState: true
        }
    })
    .prepend(apuestesAPI.middleware)
})

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
